import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/iconBox";
import { Constant, imageDomain } from "../helper/Constants";

const IconBox = () => {
  const [amenities, setAmenities] = useState([]);

  useEffect(() => {
    loadAmenities();
  }, []);

  const loadAmenities = async () => {
    try {
      const resp = await axios.get(
        `${Constant.getUrls.getAllAmenities}?page=1&limit=4`,
      );
      if (resp.data?.status === "success") {
        setAmenities(resp.data.data.slice(0, 4));
      }
    } catch {
      setAmenities([]);
    }
  };

  return (
    <Styles>
      <div
  className="icon-box-area"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 400px)", // ✅ fixed card width
    gap: "20px",
    justifyContent: "center", // ✅ centers grid
    marginTop: window.innerWidth <= 500 ? 200 : 0,
  }}
>
  {amenities.map((item, i) => (
    <div key={item._id || i}>
      <div className="full-icon-box">
        <div
          className="icon-box d-flex"
          style={{
            width: 410, // ✅ SAME as grid column
            alignItems: "center",
            gap: "20px",
            padding: "20px 22px",
            minHeight: 110,
          }}
        >
          <div
            style={{
              minWidth: 65,
              height: 65,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={
                item.icon.startsWith("http")
                  ? item.icon
                  : imageDomain + item.icon
              }
              alt={item.title}
              style={{
                width: 55,
                height: 55,
                objectFit: "contain",
              }}
            />
          </div>

          <div>
            <h6 style={{ marginBottom: 6, fontSize: 20 }}>
              {item.title}
            </h6>
            <p style={{ margin: 0, fontSize: 18 }}>{item.text}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

    </Styles>
  );
};

export default IconBox;
